var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{staticClass:"loader-next",attrs:{"width":_vm.sizeInPx,"height":_vm.sizeInPx,"viewBox":"-30 -30 60 60"}},[_c('circle',{staticClass:"loader-next__circle",attrs:{"cx":"0","cy":"0","r":"27"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }